export const existActivity = state => state.existActivity // 是否有硬件参与押金活动
export const authType = state => state.authType // 商户实名认证类型 1对私 2对公
